import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import './Navbar.css';

// import coeLogo from '../../Assets/Images/Logo/CoElogo.png';
import coeLogo from '../../Assets/Images/Logo/CoElogo1_white.jpeg';
import spaLogo from '../../Assets/Images/Logo/spaLogo.jpeg';
import mohua_logo from '../../Assets/Images/Logo/mohua_logo.png';

import Rethinking_Public_Spaces_Under_Fly_Overs from '../../Assets/Images/ProjectsImg/Rethinking Public Spaces Under Fly-Overs/Rethinking Public Spaces Under Fly-Overs.jpeg';
import Using_Building_Envelopes_as_Heat_Sink_to_Manage_Urban_Heat_Island_In_Developing_Countries from '../../Assets/Images/ProjectsImg/Using Building Envelopes as Heat Sink to Manage Urban Heat Island (UHI) In Developing Countries/urbanHeatPoster.jpg';
import Determinants_of_Successful_Public_Parks_and_Open_Spaces from '../../Assets/Images/ProjectsImg/Determinants of Successful Public Parks and Open Spaces (SPPOS)/SPPOS.jpeg';
import Urban_Growth_and_Environment_Observatory_Lab from '../../Assets/Images/ProjectsImg/Urban Growth and Environment Observatory/UHI_Analysis_2023.jpg';
import Delhi_Cantonment_Board__Urban_Flooding from '../../Assets/Images/ProjectsImg/Delhi Cantonment Board – Urban Flooding/Study area_page-0001.jpg';
import Jalandhar_Junction_Improvement from '../../Assets/Images/ProjectsImg/Jalandhar – Junction (4) Improvement/Jalandher.jpg';
import Municipal_Corporation_of_Sambalpur from '../../Assets/Images/ProjectsImg/Municipal Corporation of Sambalpur/Sambalpur.png';
import Mahakumbh_Mobility_and_Urban_Infrastructure from '../../Assets/Images/ProjectsImg/Mahakumbh, Mobility and Urban Infrastructure/Kumbh.jpg';
import Kumbh2 from '../../Assets/Images/ProjectsImg/Mahakumbh, Mobility and Urban Infrastructure/Kumbh2.jpg';

const Navbar = () => {
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isTouchMode, setIsTouchMode] = useState(window.innerWidth < 1024); // Treat tablet as mobile

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleDropdown = (item) => {
        setActiveDropdown((prev) => (prev === item ? null : item));
    };

    useEffect(() => {
        const handleResize = () => {
            setIsTouchMode(window.innerWidth < 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const menuItems = [
        { title: "Home", path: "/", subItems: [] },
        {
            title: "About", path: "/about", subItems: [
                { title: "About Us", path: "/about" },
                { title: "Director Desk", path: "/about/directorDesk" },
                // { title: "Deputy Team Leader Desk", path: "/about/deputyTeamLead" },
                { title: "Core Team", path: "/about/coreTeam" },
                { title: "Team Members", path: "/about/teamMember" },
                // { title: "Administrative Staff", path: "/about/administrativeStaff" },
                { title: "Brochure", path: "/about/brochure" },
            ]
        },
        {
            title: "Projects", path: "/projects", subItems: [
                // {
                //     title: "Documentation Study on Transport & Infrastructure of Kumbh Mela 2025",
                //     path: "/project/Mahakumhb_Mobility_and_Urban_Infrastructure",
                //     state: {
                //         id: 4,
                //         path: "Mahakumhb_Mobility_and_Urban_Infrastructure",
                //         thumbnailSrc: Kumbh2,
                //         title: "Documentation Study on Transport & Infrastructure of Kumbh Mela 2025",
                //         paragraph: "Data",
                //         timeline: 'Feb 2025 - April 2025',
                //         status: 'Completed',
                //         teamMember: [
                //             { id: 1, name: `Prof. Dr. Dr. Sewa Ram` },
                //             { id: 2, name: `Prof. Dr. Poonam Prakash` },
                //             { id: 3, name: `Dr. Sairam Dasari` },
                //             { id: 4, name: `Karan Barpete` },
                //             { id: 5, name: `Monika Singh` },
                //             { id: 6, name: `Solanki Ghosh` },
                //             { id: 7, name: `Niket S. Devkar` },
                //             { id: 8, name: `Abhinav Gupta` },
                //         ]
                //     },
                // },
                // {
                //     title: "Drainage Augmentation Plan for NH 8, Dhaula Kuan",
                //     path: "/project/Delhi_Cantonment_Board__Urban_Flooding",
                //     state: {
                //         id: 5,
                //         path: 'Delhi_Cantonment_Board__Urban_Flooding',
                //         thumbnailSrc: Delhi_Cantonment_Board__Urban_Flooding,
                //         title: "Drainage Augmentation Plan for NH 8, Dhaula Kuan",
                //         paragraph: "New Delhi experiences persistent situation of water logging and flooding particularly during heavy rain which obstructs the traffic flow. This highlights the system’s inability to cope with increased water volume. The existing drainage infrastructure is inadequate to manage the runoff which necessitates current improvements to manage future flooding. The scope of the work highlights in low-cost management of drainage infrastructure through the possibilities of exploring existing management of blue green places in the vicinity of the area. It also highlights water sensitive urban design aspects and more particularly sponge city principle can be incorporated in micro level planning.",
                //         timeline: '30 September 2024 - Till Now',
                //         status: 'On going',
                //         teamMember: [
                //             { id: 1, name: `Prof. Dr. Sewa Ram` },
                //             { id: 2, name: `Prof. Dr. Rabidyuti Biswas` },
                //             { id: 3, name: `Dr. Sairam Dasari` },
                //             { id: 4, name: `Ms. Sudeshna Mitra` },
                //         ]
                //     },
                // },
                // {
                //     title: "Redevelopment of streets and public spaces in Jalandhar",
                //     path: "/project/project6",
                //     state: {
                //         id: 6,
                //         path: 'Jalandhar_Junction_Improvement',
                //         thumbnailSrc: Jalandhar_Junction_Improvement,
                //         title: "Redevelopment of streets and public spaces in Jalandhar",
                //         paragraph: "The Centre of Excellence at SPA Delhi is actively engaged in projects aimed at improving urban road stretches and beautifying key urban areas through strategic junction improvements. These initiatives focus on enhancing pedestrian safety, ensuring smoother traffic movement, and creating more inclusive, accessible, and aesthetically appealing public spaces. By redesigning road sections and intersections based on context-sensitive solutions, the projects aim to integrate dedicated pedestrian walkways, cycle tracks, and universal access features into the existing urban fabric. Traffic calming elements such as raised crossings, compact roundabouts, and visual cues are introduced to improve road user behavior and safety. Simultaneously, junctions are being transformed into vibrant urban nodes through landscape design, public art, and improved lighting, contributing to both functionality and visual identity. These interventions not only address critical mobility challenges but also enhance the overall public realm, making streets more livable and responsive to the diverse needs of all users.",
                //         timeline: '4 March 2025 - Till Now',
                //         status: 'On going',
                //         teamMember: [
                //             { id: 1, name: `Prof. Dr. Sewa Ram` },
                //             { id: 2, name: `Dr. Poonam Saini` },
                //             { id: 3, name: `Ms. Pragati Chauhan` },
                //             { id: 4, name: `Niket S. Devkar` },
                //         ]
                //     },
                // },
                // {
                //     title: "Master plan for Sambalpur, 2047",
                //     path: "/project/Municipal_Corporation_of_Sambalpur",
                //     state: {
                //         id: 7,
                //         path: 'Municipal_Corporation_of_Sambalpur',
                //         thumbnailSrc: Municipal_Corporation_of_Sambalpur,
                //         title: "Master plan for Sambalpur, 2047",
                //         paragraph: "Under the Centre of Excellence, this project supports the Municipal Corporation of Sambalpur in advancing sustainable and inclusive urban development. It focuses on the preparation of the Master Plan, junction improvement to ease traffic flow and enhance safety, and the upgradation of parks and playgrounds to improve the quality of public spaces and promote community well-being. By focusing on core urban infrastructure, mobility, and public space enhancement, the project aims to make Sambalpur more livable, efficient, and citizen-centric. It emphasizes integrated planning, design innovation, and evidence-based decision-making to guide the city’s future growth. This initiative reflects a model of collaboration between local governments and Center of Excellence, demonstrating how mid - sized cities can implement targeted interventions to address urban challenges.Through this approach, Sambalpur is positioned as a forward - looking urban center, with scalable solutions that can be replicated in similar city contexts across India.",
                //         timeline: '2nd June 2025 - Till Now',
                //         status: 'On going',
                //         teamMember: [
                //             { id: 1, name: `Prof. Dr. Ashok Kumar` },
                //             { id: 2, name: `Prof. Dr. Rabidyuti Biswas` },
                //             { id: 3, name: `Dr. Chetna Singh` },
                //             { id: 4, name: `Md. Lukman Khan` },
                //             { id: 5, name: `Ms Sudeshna Mitra` },
                //         ]
                //     },
                // },
                // {
                //     title: "Improvement of Junctions, Upgradation of parks and playground",
                //     path: 'project/Improvement_of_Junctions_Upgradation_of_parks_and_playground',
                //     state: {
                //         id: 9,
                //         path: 'project/Improvement_of_Junctions_Upgradation_of_parks_and_playground',
                //         thumbnailSrc: null,
                //         title: "Improvement of Junctions, Upgradation of parks and playground",
                //         paragraph: `Park and Playground`,
                //         timeline: 'June 2025',
                //         status: 'On going',
                //         teamMember: [
                //             { id: 1, name: `Prof. Dr. Sewa Ram` },
                //             { id: 2, name: `Dr. Aarti Grover` },
                //             { id: 3, name: `Ms. Pragati Chauhan` },
                //         ]
                //     },
                // },
                // {
                //     title: "Post Office Beautifications and Branding",
                //     path: "/project/Post_Office_Beautifications_and_Branding",
                //     state: {
                //         id: 3,
                //         path: 'Post_Office_Beautifications_and_Branding',
                //         thumbnailSrc: null,
                //         title: "Post Office Beautifications and Branding",
                //         paragraph: null,
                //         timeline: '2025',
                //         status: 'On going',
                //         teamMember: [
                //             { id: 1, name: `Parag Anand Meshram` },
                //             { id: 2, name: `Aditi Singh` },
                //             { id: 3, name: `Manu Mahajan` },
                //             { id: 4, name: `Abhijeet Rastogi` },
                //         ]
                //     },
                // },
            ]
        },
        {
            title: "Training", path: "/training/trainingPrograms", subItems: [
                { title: "Training Programs", path: "/training/trainingPrograms" },
                { title: "Certificate Courses", path: "/training/certificateCourses" },
                { title: "Training Compendium", path: "/training/trainingCompendium" },
            ]
        },
        {
            title: "Research", path: "/research/researchProject", subItems: [
                { title: "Research", path: "/research/researchProject" },
                { title: "Publication", path: "/research/publication" },
            ]
        },
        {
            title: "Collaborations", path: "/collaboration/govt", subItems: [
                // { title: "Government", path: "/collaboration/govt" },
                // { title: "Urban Local Bodies", path: "/collaboration/ulb" },
                // { title: "Corporate", path: "/collaboration/corporate" }
            ]
        },
        // {
        //     title: "Collaborations", path: "/collaboration", subItems: [
        //         // { title: "Government", path: "/collaboration/govt" },
        //         // { title: "Urban Local Bodies", path: "/collaboration/ulb" },
        //         // { title: "Corporate", path: "/collaboration/corporate" }
        //     ]
        // },
        {
            title: "Knowledge Repository", path: "/knowledgeRepository", subItems: []
        },
        // { title: "Careers", path: "/careers", subItems: [] },
        {
            title: "Contacts", path: "/contact", subItems: [
                { title: "Contact US", path: "/contact" },
                { title: "Important Links", path: "/importantLinks" },
                { title: "Vacancies", path: "/vacancies" }
            ]
        },
    ];

    return (
        <>
            {/* Top Header */}
            <div className="navbar-top-header">
                <div className="container d-flex align-items-center justify-content-between">
                    <div className='d-flex'>
                        <Link to="/">
                            <img src={coeLogo} alt="SPA Logo" className="navbar-logo" />
                        </Link>
                        <div className="navbar-header-text">
                            <h3>Centre of Excellence - Urban Planning and Design</h3>
                            <p className='mb-1'>(Ministry of Housing and Urban Affairs, Government of India)</p>
                            <h5>School of Planning and Architecture, New Delhi</h5>
                            <p>(An Institution of National Importance under an Act of Parliament,<br />
                                Ministry of Education, Government of India)</p>
                        </div>
                    </div>
                    <div>
                        <Link to="https://spa.ac.in/" target="_blank">
                            <img src={spaLogo} alt="School of Planning and Architecture (SPA)" className="navbar-logo" />
                        </Link>
                        <Link to="https://mohua.gov.in/" target="_blank">
                            <img src={mohua_logo} alt="Ministry of Housing and Urban Affairs" className="navbar-logo" />
                        </Link>
                    </div>
                </div>
            </div>

            {/* Main Navbar */}
            <nav className="navbar navbar-expand-lg main-navbar shadow-sm" >
                <div className="container">
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleMenu}
                        aria-controls="navMenu"
                        aria-expanded={isMenuOpen}
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>

                    <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navMenu">
                        <ul className="navbar-nav mx-auto fw-bold text-uppercase">
                            {menuItems.map((item, index) => (
                                <li
                                    className={`nav-item ${item.subItems.length > 0 ? 'dropdown' : ''}`}
                                    key={index}
                                    onMouseEnter={() => !isTouchMode && item.subItems.length > 0 && setActiveDropdown(item.title)}
                                    onMouseLeave={() => !isTouchMode && item.subItems.length > 0 && setActiveDropdown(null)}
                                >
                                    {item.subItems.length > 0 ? (
                                        <div
                                            className="nav-link d-flex justify-content-between align-items-center"
                                            onClick={() => isTouchMode && toggleDropdown(item.title)}
                                        >
                                            <Link to={item.path} className="text-black text-decoration-none">
                                                <span>{item.title}</span>
                                            </Link>
                                            <span className="dropdown-icon">▼</span>
                                        </div>
                                    ) : (
                                        <Link className="nav-link text-black" to={item.path} state={item?.item?.subItems?.state}>{item.title}</Link>
                                    )}

                                    {item.subItems.length > 0 && (
                                        <ul className={`dropdown-menu ${activeDropdown === item.title ? 'show' : ''}`}>
                                            {item.subItems.map((subItem, subIndex) => (
                                                <li key={subIndex}>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={subItem.path}
                                                        state={subItem?.state}
                                                    >
                                                        {subItem.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
